// extracted by mini-css-extract-plugin
module.exports = {"licon":"LoadingIcon-module__licon___1wB1Z"};